import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './component/Sidebar';

function Livreur(){
  const navigate = useNavigate();
  const [livreurs, setLivreurs] = useState([]);
  const [form, setForm] = useState({ idlivreur: null, nomlivreur: '', telephone: '', secteur: '' });
  const [selectedLivreur, setSelectedLivreur] = useState(null);
  const [stats, setStats] = useState({ nb_en_cours: 0, commandes: [] });
  const [history, setHistory] = useState([]);

  const base = 'https://jojomarket.org/adminfood/';
  const urlList = base + 'functionlivreur.php?getlivreur';

  const loadLivreurs = async () => {
    const res = await axios.get(urlList);
    setLivreurs(res.data || []);
  };

  const resetForm = () => setForm({ idlivreur: null, nomlivreur: '', telephone: '', secteur: '' });

  const addLivreur = async () => {
    if(!form.nomlivreur){ alert('Nom requis'); return; }
    const url = `${base}functionlivreur.php?addlivreur&nomlivreur=${encodeURIComponent(form.nomlivreur)}&telephone=${encodeURIComponent(form.telephone)}&secteur=${encodeURIComponent(form.secteur)}`;
    await axios.get(url);
    resetForm();
    loadLivreurs();
  };

  const updateLivreur = async () => {
    if(!form.idlivreur){ return; }
    const url = `${base}functionlivreur.php?updatelivreur&idlivreur=${form.idlivreur}&nomlivreur=${encodeURIComponent(form.nomlivreur)}&telephone=${encodeURIComponent(form.telephone)}&secteur=${encodeURIComponent(form.secteur)}`;
    await axios.get(url);
    resetForm();
    loadLivreurs();
  };

  const deleteLivreur = async (id) => {
    if(!window.confirm('Supprimer ce livreur ?')) return;
    const url = `${base}functionlivreur.php?deletelivreur&idlivreur=${id}`;
    await axios.get(url);
    loadLivreurs();
  };

  const openStats = async (livreur) => {
    setSelectedLivreur(livreur);
    const url = `${base}functionlivreur.php?livreur_stats&idlivreur=${livreur.idlivreur}`;
    const res = await axios.get(url);
    setStats(res.data || { nb_en_cours: 0, commandes: [] });
    const modal = new window.bootstrap.Modal(document.getElementById('statsModal'));
    modal.show();
  };

  const openHistory = async (livreur) => {
    setSelectedLivreur(livreur);
    const url = `${base}functioncommande.php?livreur_history&idlivreur=${livreur.idlivreur}`;
    const res = await axios.get(url);
    setHistory(res.data || []);
    const modal = new window.bootstrap.Modal(document.getElementById('historyModal'));
    modal.show();
  };

  useEffect(() => {
    if(!sessionStorage.getItem('Token')){ navigate('/login'); return; }
    loadLivreurs();
  }, []);

  return (
    <div>
      <Sidebar/>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
          <div className="container-fluid py-1 px-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
                <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Livreur</li>
              </ol>
              <h6 className="font-weight-bolder mb-0">Gestion Livreurs</h6>
            </nav>
          </div>
        </nav>
      <div className="container-fluid py-4">
      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-header pb-0 d-flex justify-content-between align-items-center">
              <h6>Livreurs</h6>
              <Link className="btn btn-sm btn-outline-primary" to="/home">Retour</Link>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive">
                <table className="table align-items-center mb-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Livreur</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Téléphone</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Secteur</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {livreurs && livreurs.map(l => (
                      <tr key={l.idlivreur}>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="text-xs font-weight-bold">{l.nomlivreur}</span>
                            <small className="text-muted">#{l.idlivreur}</small>
                          </div>
                        </td>
                        <td className="text-center"><span className="text-xs">{l.telephone}</span></td>
                        <td className="text-center"><span className="text-xs">{l.secteur}</span></td>
                        <td className="text-center">
                          <div className="btn-group btn-group-sm" role="group">
                            <button className="btn btn-outline-info" onClick={() => openStats(l)}>
                              En cours
                            </button>
                            <button className="btn btn-outline-secondary" onClick={() => openHistory(l)}>
                              Historique
                            </button>
                            <button className="btn btn-outline-warning" onClick={() => setForm({ idlivreur: l.idlivreur, nomlivreur: l.nomlivreur, telephone: l.telephone, secteur: l.secteur })} data-bs-toggle="modal" data-bs-target="#editModal">
                              Modifier
                            </button>
                            <button className="btn btn-outline-danger" onClick={() => deleteLivreur(l.idlivreur)}>
                              Supprimer
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card">
            <div className="card-header pb-0"><h6>Ajouter un livreur</h6></div>
            <div className="card-body">
              <div className="mb-2">
                <label className="form-label">Nom</label>
                <input className="form-control" value={form.nomlivreur} onChange={e => setForm({...form, nomlivreur: e.target.value})} />
              </div>
              <div className="mb-2">
                <label className="form-label">Téléphone</label>
                <input className="form-control" value={form.telephone} onChange={e => setForm({...form, telephone: e.target.value})} />
              </div>
              <div className="mb-3">
                <label className="form-label">Secteur</label>
                <input className="form-control" value={form.secteur} onChange={e => setForm({...form, secteur: e.target.value})} />
              </div>
              <button className="btn btn-primary w-100" onClick={addLivreur}>Enregistrer</button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal edit */}
      <div className="modal fade" id="editModal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modifier livreur</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">Nom</label>
                <input className="form-control" value={form.nomlivreur} onChange={e => setForm({...form, nomlivreur: e.target.value})} />
              </div>
              <div className="mb-2">
                <label className="form-label">Téléphone</label>
                <input className="form-control" value={form.telephone} onChange={e => setForm({...form, telephone: e.target.value})} />
              </div>
              <div className="mb-3">
                <label className="form-label">Secteur</label>
                <input className="form-control" value={form.secteur} onChange={e => setForm({...form, secteur: e.target.value})} />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
              <button type="button" className="btn btn-primary" onClick={updateLivreur} data-bs-dismiss="modal">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal stats */}
      <div className="modal fade" id="statsModal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-gradient-primary">
              <h5 className="modal-title text-white">Commandes en cours - {selectedLivreur ? selectedLivreur.nomlivreur : ''}</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p className="mb-3"><strong>Nombre:</strong> {stats.nb_en_cours}</p>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Commande</th>
                      <th>Date</th>
                      <th className="text-end">Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.commandes && stats.commandes.map((c, idx) => (
                      <tr key={idx}>
                        <td>#{c.idcommande}</td>
                        <td>{new Date(c.datecommande).toLocaleString('fr-FR')}</td>
                        <td className="text-end text-success fw-bold">{(parseFloat(c.montant)||0).toLocaleString('fr-FR')} FCFA</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal history */}
      <div className="modal fade" id="historyModal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-gradient-secondary">
              <h5 className="modal-title text-white">Historique - {selectedLivreur ? selectedLivreur.nomlivreur : ''}</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Commande</th>
                      <th>Date</th>
                      <th>Adresse</th>
                      <th className="text-end">Montant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history && history.map((h, idx) => (
                      <tr key={idx}>
                        <td>#{h.idcommande}</td>
                        <td>{new Date(h.datecommande).toLocaleString('fr-FR')}</td>
                        <td>{h.adresse}</td>
                        <td className="text-end text-success fw-bold">{(parseFloat(h.prix)||0).toLocaleString('fr-FR')} FCFA</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
      </div>
      </main>
    </div>
  );
}

export default Livreur;


